import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, FileTextIcon, SmartphoneIcon, ShieldIcon, RefreshCwIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function IncludesSection() {
  const items = [{
    icon: BookOpenIcon,
    title: 'Ebook + Journal guiado',
    desc: '14 días de acompañamiento paso a paso.'
  }, {
    icon: FileTextIcon,
    title: 'Plantilla RU',
    desc: 'La página de emergencia para el pico de ansiedad.'
  }, {
    icon: SmartphoneIcon,
    title: 'Detox digital',
    desc: 'Estrategia realista para no stalkear.'
  }, {
    icon: ShieldIcon,
    title: "Protocolo 'si aparece'",
    desc: 'Qué responder sin temblar.'
  }, {
    icon: RefreshCwIcon,
    title: "Protocolo 'si recaigo'",
    desc: 'Para que un error no sea el fin.'
  }];
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 px-6 relative" data-id="element-143">
      <div className="max-w-6xl mx-auto" data-id="element-144">
        <div className="text-center mb-16" data-id="element-145">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-146">
            Todo lo que recibes
          </h2>
          <p className="text-[#A8A8B3]" data-id="element-147">
            Formato PDF Digital · Acceso Inmediato
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-148">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`glass-card p-6 rounded-xl flex items-start gap-4 hover:bg-white/5 transition-colors ${index === items.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-149">
              <div className="p-3 rounded-lg bg-gradient-to-br from-[#E8636F]/20 to-[#F4A261]/20 text-[#F4A261]" data-id="element-150">
                <item.icon className="w-6 h-6" data-id="element-151" />
              </div>
              <div data-id="element-152">
                <h3 className="text-lg font-bold text-white mb-1" data-id="element-153">
                  {item.title}
                </h3>
                <p className="text-[#A8A8B3] text-sm" data-id="element-154">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative rounded-2xl overflow-hidden mb-12" data-id="element-155">
          <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F14] via-transparent to-transparent z-10" data-id="element-156"></div>
          <img src="https://cdn.magicpatterns.com/uploads/bMfiQ7rRWoqVNjHTPgWiVx/mockup1.png" alt="Product Mockup" className="w-full h-auto object-cover opacity-80" data-id="element-157" />
        </motion.div>

        <div className="text-center" data-id="element-158">
          <Button onClick={scrollToPricing} className="px-10 py-4 text-lg" data-id="element-159">
            Quiero mi copia ahora
          </Button>
        </div>
      </div>
    </section>;
}